import { Injectable } from '@angular/core';

const ENV = window['__env'];

@Injectable({
    providedIn: 'root'
})
export class EnvironmentService {
    private env = ENV;

    public get(key: any): string {
        return this.env[key];
    }
    public getUrl(key: any): string {
        return 'https://' + this.env[key];
    }

    public setCustom(key: any, val: any) {
        this.env[key] = val;
    }
}
